import React, { Component } from 'react';

export default class EmptyImage extends Component {
  render() {
    const { onUpload, position } = this.props;

    return (
      <div className="collection new_image">
        <div className="collection-overlay">
          <div className="collection-overlay-wrapper text-center" style={{ paddingTop: 95 }}>
            <label className="btn btn-primary btn-lg" title="Add image">
              <div className="form-group file optional image_image hide">
                <label className="file optional control-label" htmlFor="image_image">Image</label>
                <input className="file optional" type="file" onChange={(e) => onUpload(position, e)}/>
              </div>
              Add image
            </label>
          </div>
        </div>
      </div>
    )
  }
}
